import { Button } from 'evergreen-ui'
import React from 'react'
import { Link } from 'react-router-dom'
import CardSection from './AllCampaigns/CardSection'
import { useBreakpoint } from '/fiweb/lib'
import { useCustomTheme } from '/fiweb/lib/theme'
import { useCampaignsHomeSubQuery } from '/~/hooks/useCampaignsHomeSubQuery'
import { sortOngoingCampaignCards } from '/~/utils/arraySorting'

interface Props {
  title?: string
  description?: string
  maxCardsDisplayed?: number
}

const FeaturedCampaignCards = ({ title, description, maxCardsDisplayed }: Props) => {
  const { ongoing } = useCampaignsHomeSubQuery()
  const sortedOngoing = sortOngoingCampaignCards(ongoing)
  const { colors, spacing } = useCustomTheme()
  const { large } = useBreakpoint()

  const cards = sortedOngoing.slice(0, maxCardsDisplayed)

  return (
    <CardSection
      name='frontpageOngoing'
      cards={cards}
      title={title || 'Dagens investeringsmuligheter'}
      ctaButton={
        <Button size='small' is={Link} to='/kampanjer'>
          Se alle emisjoner
        </Button>
      }
      description={description || ''}
      ignoreAdCard={cards.length % (large ? 2 : 3) === 0}
      paneProps={{
        background: colors.fiTint,
        paddingTop: spacing.s,
        paddingBottom: spacing.m,
      }}
    />
  )
}

export default FeaturedCampaignCards
